import ModalEditAnnouncement from "./ModalEditAnnouncement";

export default ModalEditAnnouncement;
